import { Instagram, Facebook, Twitter, Linkedin, MessageCircle, Smartphone } from "lucide-react";

// Lucide React icons for platform display
export const PLATFORM_ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  twitter: Twitter,
  linkedin: Linkedin,
  threads: MessageCircle,
  default: Smartphone,
} as const;

// Platform styles for consistent theming
export const PLATFORM_STYLES = {
  instagram: {
    color: "#D62976",
    bg: "bg-rose-50",
    border: "border-transparent",
    badgeDot: "bg-yellow-800",
  },
  facebook: {
    color: "#1877F2",
    bg: "bg-blue-50",
    border: "border-transparent",
    badgeDot: "bg-yellow-800",
  },
  threads: {
    color: "#000000",
    bg: "bg-gray-50",
    border: "border-transparent",
    badgeDot: "bg-yellow-800",
  },
  linkedin: {
    color: "#0A66C2",
    bg: "bg-sky-50",
    border: "border-transparent",
    badgeDot: "bg-yellow-800",
  },
  twitter: {
    color: "#111827",
    bg: "bg-gray-50",
    border: "border-transparent",
    badgeDot: "bg-yellow-800",
  },
  default: {
    color: "#3B82F6",
    bg: "bg-white",
    border: "border-transparent",
    badgeDot: "bg-yellow-800",
  },
} as const;

export const getPlatformIcon = (platform: string) => {
  const platformLower = platform?.toLowerCase() || "";

  if (platformLower === "instagram") return PLATFORM_ICONS.instagram;
  if (platformLower === "facebook") return PLATFORM_ICONS.facebook;
  if (platformLower === "twitter") return PLATFORM_ICONS.twitter;
  if (platformLower === "linkedin") return PLATFORM_ICONS.linkedin;
  if (platformLower === "threads") return PLATFORM_ICONS.threads;

  return PLATFORM_ICONS.default;
};

export const getPlatformStyle = (platform: string) => {
  const platformLower = platform?.toLowerCase() || "";

  switch (platformLower) {
    case "instagram":
      return PLATFORM_STYLES.instagram;
    case "facebook":
      return PLATFORM_STYLES.facebook;
    case "threads":
      return PLATFORM_STYLES.threads;
    case "linkedin":
      return PLATFORM_STYLES.linkedin;
    case "twitter":
    case "x":
      return PLATFORM_STYLES.twitter;
    default:
      return PLATFORM_STYLES.default;
  }
};
